import React from 'react';
import { Link } from 'react-router-dom';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-5">
      <div className="max-w-md w-full text-center space-y-4">
        <h1 className="text-xl font-semibold text-neutral-900" data-testid="donation-cancel-title">No worries!</h1>
        <p className="text-sm text-neutral-500">Your donation was cancelled — nothing was charged.</p>
        <Link to="/" className="inline-block text-sm text-orange-600 hover:text-orange-700 underline" data-testid="donation-cancel-back-link">
          Back to Waxify
        </Link>
      </div>
    </div>
  );
}
